import { DDSTypography } from 'den-design-system'
import React from 'react'
import arrowRightIcon from '../../assets/icons/arrowRight.svg'
import pallete from '../../global/newPallete'
import { replaceUrl } from '../../utils/UrlUtils'
import { useNavigate } from 'react-router-dom'
import { useStoreContext } from '../../store/StoreContext'

interface AbsoluteUsageWithTitle {
  title: string
  value: number
}
interface MetadataCardProps {
  title: string
  link?: string
  total: AbsoluteUsageWithTitle
  limit?: AbsoluteUsageWithTitle
}

const SFMetadataCard: React.FC<MetadataCardProps> = ({
  title,
  link,
  total,
  limit
}) => {
  const navigate = useNavigate()
  const { scopeStore } = useStoreContext()

  const handleNavigation = (link: string) => {
    navigate(
      replaceUrl(
        link,
        scopeStore.getScope()['organization-id'] as string,
        scopeStore.getScope()['project-id'] as string,
        scopeStore.getScope()['environment-id'] as string
      )
    )
  }

  return (
    <div className='w-full max-w-xs rounded-xl border border-gray-200 p-[16px] shadow-sm bg-white'>
      <div
        className={`flex items-center gap-[8px] ${link ? 'cursor-pointer' : ''}`}
        onClick={() => link && handleNavigation(link)}
      >
        <DDSTypography.Title
          type='h5'
          variant='semiBold'
          color={pallete.colors.textDark4}
          style={{
            wordBreak: 'break-word',
            hyphens: 'auto'
          }}
        >
          {title}{' '}
        </DDSTypography.Title>
        {link && <img src={arrowRightIcon} alt='Arrow' className='h-[16px]' />}
      </div>

      <div className='grid grid-cols-2 gap-[16px] mt-[24px]'>
        <div className={`${!limit ? 'col-span-2' : ''}`}>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={pallete.colors.textDark4}
            className='pb-[8px]'
            style={{
              wordBreak: 'break-word',
              hyphens: 'auto'
            }}
          >
            {total.title}
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
            style={{
              wordBreak: 'break-word'
            }}
          >
            {total.value.toLocaleString('en-US')}
          </DDSTypography.Title>
        </div>

        {limit && (
          <div>
            <p className='text-sm font-semibold text-gray-500'>{limit.title}</p>
            <h4 className='text-xl font-bold text-black'>
              {limit.value.toLocaleString('en-US')}
            </h4>
          </div>
        )}
      </div>
    </div>
  )
}

export default SFMetadataCard
